import Clickable from 'components/Common/Clickable'
import { getRestoreCartUriForId } from 'checkout/lib/utils/misc/restoreCartUtils'
import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const BannerLink = styled(Clickable)`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: ${rem(52)};
  padding: ${rem(12)} ${rem(16)};
  text-align: start;
  background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-bottom: 0;
  color: ${props => props.theme.palette.neutral.default.one};
`

interface Props {
  transactionKey: string
}

function OneClickBookingRestorationBanner({ transactionKey }: Props) {
  const intl = useIntl()

  return <BannerLink to={getRestoreCartUriForId(transactionKey)}>
    <BodyTextBlock
      variant="medium"
      colour="neutral-one"
      weight="bold"
      endIcon={<LineArrowRightIcon />}
    >
      {intl.formatMessage({
        id: 'sV0kE1j3siCFG-iu7gYM',
        defaultMessage: 'Continue with your booking',
        description: 'Banner text shown above a hotel search result when the user has a matching checkout cart to continue',
      })}
    </BodyTextBlock>
  </BannerLink>
}

export default OneClickBookingRestorationBanner
